function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.995 2.25c-3.603-.022-6.789 3.118-6.784 6.749v.897c.04 3.712-.811 6.19-1.582 7.516l-.001.003a.09.09 0 00.077.135h16.59a.089.089 0 00.078-.045.09.09 0 000-.09l-.002-.003c-.772-1.328-1.581-3.646-1.581-7.512v-.745c0-3.763-3.057-6.877-6.795-6.905zM3.711 9C3.705 4.532 7.574.724 12.005.75c4.576.034 8.285 3.831 8.285 8.405V9.9c0 3.655.764 5.702 1.378 6.759l-.649.377.648-.38a1.59 1.59 0 01-1.368 2.394H16.11v.09a4.11 4.11 0 01-8.22 0v-.09H3.7a1.59 1.59 0 01-1.368-2.392c.616-1.06 1.416-3.266 1.378-6.75V9zM9.39 19.05v.09a2.61 2.61 0 005.22 0v-.09H9.39z",
  fill: "#333"
});
function SvgAssist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgAssist;